import React, {useState} from "react";
import {PlusOutlined} from "@ant-design/icons";
import {CustomButton} from "../../_defaultComponents/CustomButton/CustomButton";
import {useTranslation} from "react-i18next";
import {ActionButtonsPropTypes} from "./ComponentPropTypes";
import {ActionButtonsContainer} from "./ComponentStyles";
import CreateModal from "./CreateModal/CreateModal";

const ActionButtons = ({setReloadData}: ActionButtonsPropTypes) => {
    const {t} = useTranslation(["companyDetail", "paymentManagement"]);
    const [showCreateModal, setShowCreateModal] = useState(false);

    const closeCreateModal = (reloadData = false) => {
        if (reloadData) setReloadData();
        setShowCreateModal(false);
    };

    return (
        <>
            <CreateModal visibility={showCreateModal} onCancel={closeCreateModal} />
            <ActionButtonsContainer>
                <CustomButton
                    type="ghost"
                    icon={<PlusOutlined />}
                    data-testid="createNewPeriod"
                    onClick={() => setShowCreateModal(true)}
                >
                    {t("paymentManagement.actions.createNewPeriod", {ns: "paymentManagement"})}
                </CustomButton>
            </ActionButtonsContainer>
        </>
    );
};

export default ActionButtons;
